import React from "react";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";

export const COATING_TYPE_INFO = (
  <>
    <div>Optional reference field only.</div>
    <div>This does not affect equipment sizing or selection.</div>
  </>
);

interface FieldInfoTipProps {
  title: React.ReactNode;
  ariaLabel: string;
}

/** Small (i) control that shows help text on hover/focus. */
const FieldInfoTip = ({ title, ariaLabel }: FieldInfoTipProps) => (
  <Tooltip title={title} placement="top">
    <button
      type="button"
      className="op-field-info-btn"
      aria-label={ariaLabel}
      onClick={(event) => event.preventDefault()}
      onMouseDown={(event) => event.preventDefault()}
    >
      <InfoCircleOutlined aria-hidden />
    </button>
  </Tooltip>
);

export default FieldInfoTip;
